import { render, staticRenderFns } from "./notificationsGenerator.vue?vue&type=template&id=a692a516&"
import script from "./notificationsGenerator.vue?vue&type=script&lang=js&"
export * from "./notificationsGenerator.vue?vue&type=script&lang=js&"
import style0 from "./notificationsGenerator.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports